import _ from 'lodash';

function getCoveragesForLocation(commercialPropertyLine, locationPublicId) {
    const locationCoverages = commercialPropertyLine.offerings.children[0].coverages.locationCoverages.children.find(
        locationCoverage => locationCoverage.value.publicID === locationPublicId
    );

    return locationCoverages ?? [];
}

function getCoveragesForBuilding(commercialPropertyLine, buildingPublicId) {
    const buildingCoverages = commercialPropertyLine.offerings.children[0].coverages.buildingCoverages.children.find(
        buildingCoverage => buildingCoverage.value.publicID === buildingPublicId
    );

    return buildingCoverages ?? [];
}

function generateColumnData(submissionVM) {
    const lobOfferingPath = 'lobData.commercialProperty.offerings';

    const lobOfferings = _.get(submissionVM, `${lobOfferingPath}.value`);

    const columnData = lobOfferings.map((lobOffering, lobIndex) => ({
        name: lobOffering.branchName,
        code: lobOffering.branchCode,
        lob: {
            path: `${lobOfferingPath}.children[${lobIndex}]`,
            data: lobOffering,
        },
    }));

    return _.sortBy(columnData, ['code']);
}

export default {
    getCoveragesForLocation,
    getCoveragesForBuilding,
    generateColumnData,
};
